import dayjs, { Dayjs } from 'dayjs';
import { useCallback, useMemo } from 'react';
import { useSearchParams } from 'react-router-dom';

export type TBulkOperationsPeriod = {
  StartDate: string;
  EndDate: string;
};

const DEFAULT_DATE_FORMAT = 'YYYY-MM-DD';

export const getWeekPeriod = (end = dayjs()) => {
  return {
    start: end.add(-6, 'days'),
    end,
  };
};

export const getMonthPeriod = (end = dayjs()) => {
  return {
    start: end.add(-1, 'month').add(1, 'day'),
    end,
  };
};

export const get3MonthsPeriod = (end = dayjs()) => {
  return {
    start: end.add(-3, 'month').add(1, 'day'),
    end,
  };
};

export const useBulkOperationsPeriodFromUrl = () => {
  const [params, setParams] = useSearchParams();

  const defaults = useMemo(() => {
    const p = getWeekPeriod();
    return {
      StartDate: p.start.format(DEFAULT_DATE_FORMAT),
      EndDate: p.end.format(DEFAULT_DATE_FORMAT),
    };
  }, []);

  const StartDate = params.get('StartDate') ?? defaults.StartDate;
  const EndDate = params.get('EndDate') ?? defaults.EndDate;

  const setPeriod = useCallback(
    (value: TBulkOperationsPeriod) => {
      setParams((prev) => {
        const next = new URLSearchParams(prev);
        next.set('StartDate', value.StartDate);
        next.set('EndDate', value.EndDate);
        next.set('Page', '1');
        return next;
      });
    },
    [setParams],
  );

  return {
    StartDate,
    EndDate,
    setPeriod,
  };
};

export type TValue = { start?: Dayjs | undefined; end?: Dayjs | undefined };

export const comparePeriod = (a?: TValue, b?: TValue) => {
  if (!a || !b) return false;
  return (
    (a.start?.isSame(b.start, 'date') && a.end?.isSame(b.end, 'date')) ?? false
  );
};

